<template>
  <el-form
    ref="form"
    :rules="rules"
    :model="currForm"
    label-width="80px"
    label-position="left"
  >
    <el-form-item label="名称" prop="name">
      <el-input
        :disabled="!edit"
        style="width: 300px"
        placeholder="最多20个字"
        v-model="currForm.name"
      ></el-input>
      <span v-if="currForm.id">当前装配人数：{{ currForm.countUsed }}</span>
    </el-form-item>

    <el-form-item label="底部Tab">
      <div class="bezel">
        <div
          class="bezel-box"
          v-for="(item, index) in currForm.homeIcon"
          :key="index"
        >
          <el-button
            class="bezel-close"
            icon="circle-close"
            @click="tapDelete(index)"
            :disabled="!edit"
          ></el-button>
          <el-input
            style="width: 464px"
            placeholder="请输入Code"
            v-model="item.moduleId"
            :disabled="!edit"
          ></el-input>
          <div class="bezel-list">
            <div class="bezel-item">
              <span class="bezel-label" v-if="!item.iconNormal"
                >未选中状态</span
              >
              <!-- <UploadImg :imgUrl.sync="item.iconNormal" :disabled="edit" /> -->
              <SUpload
                v-model="item.iconNormal"
                accept="image/*"
                type="drag"
                :size="50"
                :disabled="!edit"
                :show-file-list="false"
              />
            </div>
            <div class="bezel-item">
              <span class="bezel-label" v-if="!item.iconSelected"
                >已选中状态</span
              >
              <!-- <UploadImg :imgUrl.sync="item.iconSelected" :disabled="edit" /> -->
              <SUpload
                v-model="item.iconSelected"
                accept="image/*"
                type="drag"
                :size="50"
                :disabled="!edit"
                :show-file-list="false"
              />
            </div>
            <div class="bezel-item">
              <span class="bezel-label" v-if="!item.backToTop"
                >回到顶部按钮</span
              >
              <!-- <UploadImg :imgUrl.sync="item.backToTop" :disabled="edit" /> -->
              <SUpload
                v-model="item.backToTop"
                accept="image/*"
                type="drag"
                :size="50"
                :disabled="!edit"
                :show-file-list="false"
              />
            </div>
          </div>
          <div class="bezel-tips">尺寸要求88*89，最大50KB, 优先SVG其次png</div>
        </div>
        <el-button
          style="margin-bottom: 20px"
          type="primary"
          @click="tapAdd"
          :disabled="!edit"
          >添加</el-button
        >
      </div>
    </el-form-item>

    <el-form-item label="背景图">
      <div class="flex-row" style="align-items: flex-start">
        <div class="background-img-content">
          <div>tab栏底部背景</div>
          <SUpload
            v-model="currForm.homeIcon[0].backgroundImage"
            accept="image/*"
            type="drag"
            :size="200"
            :disabled="!edit"
            :show-file-list="false"
          />
          <div class="tips">尺寸要求402*49，最大200KB，优先webp次选png</div>
        </div>
        <div class="background-img-content">
          <div>首页背景</div>
          <SUpload
            v-model="currForm.homeIcon[0].homeBackgroundImage"
            accept="image/*"
            type="drag"
            :size="200"
            :disabled="!edit"
            :show-file-list="false"
          />
          <div class="tips">尺寸建议402*177，最大200KB，优先webp次选png</div>
        </div>
        <div class="background-img-content">
          <div>我的页面背景</div>
          <SUpload
            v-model="currForm.homeIcon[0].myBackgroundImage"
            accept="image/*"
            type="drag"
            :size="200"
            :disabled="!edit"
            :show-file-list="false"
          />
          <div class="tips">尺寸建议402*189，最大200KB，优先webp次选png</div>
        </div>
        <div class="background-img-content">
          <div>广场页背景</div>
          <SUpload
            v-model="currForm.homeIcon[0].squareBackgroundUrl"
            accept="image/*"
            type="drag"
            :size="200"
            :disabled="!edit"
            :show-file-list="false"
          />
          <div class="tips">尺寸建议402*221，最大200KB，优先webp次选png</div>
        </div>
        <div class="background-img-content">
          <div>运动页背景</div>
          <SUpload
            v-model="currForm.homeIcon[0].sportBackgroundUrl"
            accept="image/*"
            type="drag"
            :disabled="!edit"
            :show-file-list="false"
          />
          <div class="tips">支持jpg、png、gif</div>
        </div>
      </div>
    </el-form-item>
    <el-form-item label="展示排序" prop="sort">
      <el-input-number
        :min="0"
        :disabled="!edit"
        v-model="currForm.sort"
      ></el-input-number>
      <div>数字越小越靠前，数字一致时优先展示最近创建的</div>
    </el-form-item>
    <el-form-item label="皮肤效果" prop="effectImage">
      <SUpload
        v-model="currForm.effectImage"
        accept="image/*"
        type="drag"
        :size="300"
        :disabled="!edit"
        :show-file-list="false"
      />
      <div class="supload-tips">尺寸建议300 x 280，大小不超过300</div>
    </el-form-item>
    <el-form-item label="拥有学生">
      <SelectStudent
        ref="SelectStudentRef"
        :disabled="edit"
        :selectVal.sync="currForm.useType"
        :privileges="currForm.privilegeRole"
      >
      </SelectStudent>
    </el-form-item>
    <el-form-item label="角标图片">
      <SUpload
        v-model="currForm.superscript"
        accept="image/*"
        type="drag"
        :size="50"
        :disabled="!edit"
        :show-file-list="false"
      />
      <div class="tips">尺寸建议40*40，最大50KB，优先SVG其次png</div>
    </el-form-item>
  </el-form>
</template>

<script>
import UploadImg from "../../../../../components/common/UploadImg.vue";
import SelectStudent from "./SelectStudent.vue";

export default {
  components: { UploadImg, SelectStudent },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    edit: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      currForm: {
        useType: 0,
        homeIcon: [
          { moduleId: "", backToTop: "", iconNormal: "", iconSelected: "" },
        ],
        effectImage: undefined,
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        url: [{ required: true, message: "请上传头像", trigger: "change" }],
        sort: [
          {
            required: true,
            type: "number",
            message: "请输入排序",
            trigger: "change",
          },
        ],
      },
    };
  },

  watch: {
    form: {
      handler(newValue, oldVal) {
        if (newValue.homeIcon) {
          this.currForm = JSON.parse(JSON.stringify(newValue));
        }
        this.currForm.useType = newValue.useType;
        this.currForm.businessType = newValue.businessType;
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    // 点击删除
    tapDelete(index) {
      if (this.currForm.homeIcon.length <= 1) {
        return;
      }
      this.currForm.homeIcon.splice(index, 1);
    },

    // 点击添加
    tapAdd() {
      let tab = {
        moduleId: 0,
        backToTop: "",
        iconNormal: "",
        iconSelected: "",
      };
      this.currForm.homeIcon.push(tab);
    },

    // 保存
    submit(release = false) {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const uids = this.$refs.SelectStudentRef.selectItemList.map(
            (item) => item.uid
          );
          this.currForm.homeIcon.forEach((item, index) => {
            this.currForm.homeIcon[index] = { ...item, ...{ order: index } };
          });
          const params = {
            name: this.currForm.name,
            useType: this.currForm.useType,
            sort: this.currForm.sort,
            homeIcon: this.currForm.homeIcon,
            businessType: this.currForm.businessType,
            status: this.currForm.status,
            superscript: this.currForm.superscript,
            effectImage: this.currForm.effectImage,
          };
          if (this.currForm.useType === 1) {
            params.uids = uids;
          } else if (this.currForm.useType === 2) {
            params.privilegeRole =
              this.$refs.SelectStudentRef.selectPrivileges.join(",");
          }
          if (this.currForm.id) {
            params.id = this.currForm.id;
          }
          const res = await this.$http({
            url:
              this.$util.domain +
              "/adminapi/v1/personalizedComponents/addOrEdit",
            method: "post",
            body: JSON.stringify(params),
          });
          if (res.data.error === 10000) {
            if (release) {
              const response = await this.$http({
                url:
                  this.$util.domain +
                  "/adminapi/v1/personalizedComponents/change",
                method: "get",
                params: {
                  id: res.data.data,
                  status: 3,
                },
              });
              if (response.data.error === 10000) {
                this.$message.success("操作成功");
                this.$router.push("/yunying/userDiyPage");
              } else {
                this.$message.error(response.data.message || "操作失败");
              }
            } else {
              this.$message.success("操作成功");
              this.$router.push("/yunying/userDiyPage");
            }
          } else {
            this.$message.error(res.data.message || "操作失败");
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.bezel {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.bezel-box {
  min-width: 464px;
  padding: 0px 0px 0px 10px;
  margin-right: 20px;
  margin-bottom: 20px;
  border: 1px solid #bfcbd9;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.bezel-close {
  width: 44px;
  height: 34px;
  margin-top: -17px;
  margin-right: -27px;
  align-self: flex-end;
  background-color: rgba(255, 255, 255, 0);
  border-color: rgba(255, 255, 255, 0);
}

.bezel-list {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bezel-item {
  /* margin-top: -30px; */
  margin-right: 10px;
  position: relative;
}

.bezel-label {
  position: absolute;
  top: 120px;
  width: 142px;
  text-align: center;
  display: inline-block;
}

.bezel-tips {
  display: flex;
  justify-content: center;
}

.background-img-content {
  /* margin-right: 50px; */
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// BottomButton.vue?dcb0aaae